"use client";

// src/components/default/remove.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var RemoveIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `RemoveIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `RemoveIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M9.99986 10.7739L6.43894 14.3348C6.32357 14.4502 6.19937 14.5058 6.06636 14.5015C5.93336 14.4972 5.8065 14.4347 5.68578 14.314C5.56504 14.1933 5.50467 14.0643 5.50467 13.927C5.50467 13.7897 5.56504 13.6607 5.68578 13.54L9.22584 9.99991L5.66494 6.43899C5.54955 6.32362 5.494 6.19595 5.49828 6.05599C5.50254 5.91605 5.56504 5.78571 5.68578 5.66499C5.8065 5.54425 5.9355 5.48389 6.07278 5.48389C6.21005 5.48389 6.33905 5.54425 6.45978 5.66499L9.99986 9.22589L13.5608 5.66499C13.6762 5.5496 13.8038 5.49057 13.9438 5.48791C14.0837 5.48523 14.2141 5.54425 14.3348 5.66499C14.4555 5.78571 14.5159 5.91471 14.5159 6.05199C14.5159 6.18927 14.4555 6.31827 14.3348 6.43899L10.7739 9.99991L14.3348 13.5608C14.4502 13.6762 14.5092 13.8004 14.5119 13.9334C14.5145 14.0664 14.4555 14.1933 14.3348 14.314C14.2141 14.4347 14.0851 14.4951 13.9478 14.4951C13.8105 14.4951 13.6815 14.4347 13.5608 14.314L9.99986 10.7739Z"
          }
        )
      )
    );
  }
);
export {
  RemoveIcon
};
